import React, { useRef, useState, Fragment, useContext, useEffect } from "react";
import Layout from "../../Layout";
import BillingHeader from "../../Billing/BillingHeader";
import BillingTabs from "../../Billing/BillingTabs";
import BillingOverview from "../../Billing/BillingOverview";
import Text from "../../Tags/Text";
import { useUsageBilling } from "../../../apiHooks/useUsageBilling";
import { useStoreUsageBilling } from "../../../stores/useStoreUsageBilling";
import { Skeleton } from "../../ui/skeleton";
import PrintDate from "../../Tags/PrintDate";
import UsageCharts from "./UsageCharts";
import UsageLogs from "./UsageLogs";
import { useNavigate } from "react-router-dom";
import useRoleCheck from "../../../hooks/useRoleCheck";
import PageHeader from "../../PageHeader";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";

export default function UsagePage() {
  const navigate = useNavigate();
  const { activeWorkspace } = useRoleCheck();
  const { usageByProduct } = useStoreUsageBilling();
  const { isLoading } = useUsageBilling(activeWorkspace?.id);
  const captureEvent = useCaptureEvent();

  useEffect(() => {
    captureEvent("BP_PageView");
  }, [captureEvent]);

  const Loader = () => {
    return (
      <>
        <tr>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
        </tr>
        <tr>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
          <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
            <Skeleton className="h-8 w-full" />
          </td>
        </tr>
      </>
    );
  };
  return (
    <Layout>
      <PageHeader
        heading="Usage analytics"
        description="View and monitor credit usage across the workspace"
      />
      <BillingOverview
        clickUpgrade={(e) => {
          e.preventDefault();
          captureEvent("BP_ClickUpgrade");
          navigate(`/${activeWorkspace?.slug}/settings/billing/plans`);
        }}
      />
      <BillingTabs activeTab="Usage" />
      <div>
        <UsageCharts activeWorkspace={activeWorkspace} />
        <div className="mt-8 flow-root pt-6 border-t">
          <Text size="sm">Usage by Product</Text>
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 mt-3">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden border border-border rounded-[--radius]">
                <table className="min-w-full divide-y divide-border table-fixed">
                  <thead className="bg-gray-25">
                    <tr>
                      <th scope="col" className="w-3/12 px-3 py-3.5 text-left text-sm font-normal">
                        <span className="inline-flex items-center">Action</span>
                      </th>
                      <th scope="col" className="w-3/12 px-3 py-3.5 text-left text-sm font-normal">
                        Number of Actions
                      </th>
                      <th scope="col" className="w-3/12 px-3 py-3.5 text-left text-sm font-normal">
                        Credits used
                      </th>
                      <th scope="col" className="w-3/12 px-3 py-3.5 text-left text-sm font-normal">
                        Most recent use
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border bg-background">
                    {isLoading ? (
                      <Loader />
                    ) : (
                      <>
                        {usageByProduct && usageByProduct.length > 0 ? (
                          <>
                            {usageByProduct.map((item) => (
                              <tr>
                                <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
                                  {item?.display_name}
                                </td>
                                <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
                                  {item?.actions?.total}
                                </td>
                                <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
                                  {item?.credits?.consumed?.total}
                                </td>
                                <td className="w-3/12 whitespace-nowrap px-3 py-4 text-sm text-paragraph">
                                  {item?.most_recent_use ? <PrintDate date={item?.most_recent_use} /> : "-"}
                                </td>
                              </tr>
                            ))}
                          </>
                        ) : (
                          <tr>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-paragraph" colSpan={12}>
                              No data found
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <UsageLogs activeWorkspace={activeWorkspace} />
      </div>
    </Layout>
  );
}
